/**
 * Body editor for the remove step: a single drop zone listing the items
 * to delete.
 */
import React from "react"
import BuilderDropZone from "../../../Builder/BuilderDropZone.component"
import { RemoveStep } from "types/queryBuilder.types"
import { StepBodyProps } from "./stepBodyProps"

export interface RemoveStepBodyProps extends StepBodyProps<RemoveStep> {
  onAddSource: (variable: string) => void
  onRemoveSource: (variable: string) => void
}

const RemoveStepBody: React.FC<RemoveStepBodyProps> = ({
  step,
  onAddSource,
  onRemoveSource,
}) => (
  <BuilderDropZone
    label="Items to remove"
    variables={step.targets}
    onAdd={onAddSource}
    onRemove={onRemoveSource}
    emptyHint="Drag fields or specific answer options to delete"
    expandParents
  />
)

export default RemoveStepBody
